// removed by extract-text-webpack-plugin
module.exports = {"check-box-wrap":"style__check-box-wrap___24Zey","check-box":"style__check-box___1DQ39","lb-check-box":"style__lb-check-box___1hJ8-"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/checkbox/style.scss
// module id = ./components/partials/checkbox/style.scss
// module chunks = 0